// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"dc8fb0a3","436":"bd750c9c","453":"f394a27d","501":"57fdbe77","606":"7549901d","821":"fd299c86","925":"3055cbea","969":"d0bfa045"}[chunkId] + ".chunk.js";
};